// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3WZlA","title":"BackImages_title__3PLgR","images":"BackImages_images__8g0xw"};